(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('MaintenanceFormController', MaintenanceFormController);
    

    MaintenanceFormController.$inject = [
  
    ];

     function MaintenanceFormController(){
         // jshint maxstatements:false
        var vm = this;
    }

})();